import getCurrentUser from './getCurrentUser'
import { SUPER_ADMIN, ADMIN } from '@/lib/constants/securityRoles'

const userIsAdmin = () => {
  const user = getCurrentUser()

  return user &&
         user.securityRoles &&
         (user.securityRoles.includes(SUPER_ADMIN.name) || user.securityRoles.includes(ADMIN.name))
}

export default userIsAdmin
